import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';
import {
  navigateTo,
  useAuth,
  UserGrainBinNotifications,
  useGetViewer,
  useGetAccount,
} from '@amber-ui/core';

function UserNotificationsRoute() {
  const { viewer } = useGetViewer();
  // Read acct from URL search params (source of truth)
  const { acct } = useSearch({ strict: false }) as { acct?: string };
  const { account_id: session_account_id } = useAuth();
  const effectiveAccountId = acct || session_account_id || '';
  const { account } = useGetAccount({ account_id: effectiveAccountId });

  const goUserSettings = useCallback(() => {
    navigateTo('/user/settings');
  }, []);

  if (!viewer || !account) return null;

  return (
    <UserGrainBinNotifications
      account_id={effectiveAccountId}
      user_id={viewer.user.user_id}
      account={account}
      goUserSettings={goUserSettings}
      hasCurrentAccountHolder={account.account_id === viewer.account_id}
      period="2W"
    />
  );
}

export const Route = createFileRoute('/_auth/user/notifications')({
  component: UserNotificationsRoute,
});
